import { useContext } from 'react';

import {
  Col,
  Container,
  Row,
} from 'react-bootstrap';

import {
  BrandingContext,
  GeoContext,
  InsuranceDataContext,
  LayoutContext,
  NotificationsContext,
  SessionContext,
} from '../libs/contexts.js';
import {
  BaseMobileFaq,
  BaseMobileFooter,
  BaseMobileHeader,
  BaseMobileMenu,
  BaseMobileProgressBar,
  BaseMobileSidebar,
} from './base-mobile.jsx';

export const FlatMobileLayout = ({ MyOutlet }) => {

    const { layout } = useContext(LayoutContext);


    return (

        <>
            <div className="content-container">
                <FlatMobileMenu />
                <Container fluid>
                    <Row>
                        <Col className="desktop-area px-0">
                            <Container fluid>
                                <Row>
                                    <Col className='px-0'>
                                        <Container fluid>
                                            <Row>
                                                <Col>
                                                    <FlatMobileHeader />
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col>
                                                    {"yes" === layout.faq ?
                                                        <FlatMobileFaq />
                                                        :
                                                        <>
                                                            {"jump" === layout.specialView ?
                                                                <p>We are getting your quote ready, please hold...</p>
                                                                :
                                                                <MyOutlet></MyOutlet>
                                                            }</>

                                                    }

                                                </Col>
                                            </Row>
                                        </Container>
                                    </Col>
                                </Row>
                            </Container>
                        </Col>
                    </Row>
                </Container>
            </div>

            {"end" !== layout.currentScreen &&
                <FlatMobileFooter />
            }


        </>
    )


}

export const FlatMobileFooter = () => {

    return (
        <>
            <BaseMobileFooter />
        </>
    );
}

export const FlatMobileHeader = () => {

    return (
        <>
            <BaseMobileHeader />
        </>
    )

}

export const FlatMobileMenu = () => {
    return (
        <BaseMobileMenu />
    )
}

export const FlatMobileProgressBar = () => {

    return (
        <BaseMobileProgressBar />
    )

}

export const FlatMobileSidebar = () => {

    return (
        <BaseMobileSidebar />
    )

}
